<div
  class="row"
  [ngClass]="{ 'fgbcl-predictor': groupType == groupTypes.Predictor, 'fgbcl-trivia': groupType == groupTypes.Trivia }"
>
  <ng-container *ngIf="gamesGroup.length > 0; else noGame">
    <div class="col-12 col-lg-4 mb-4" *ngFor="let item of gamesGroup">
      <fgbcl-games-group-item
        (comingSoonEndEmitter)="checkComingSoon($event)"
        (gameEndedEmitter)="checkGameEnded($event)"
        [gameGroupItem]="item"
        [groupType]="groupType"
        (sortGamesEmitter)="sortGameGroups($event)"
      ></fgbcl-games-group-item>
    </div>
  </ng-container>
  <!--Placeholder Information-->
  <ng-template #noGame>
    <div class="games-placeholder">
      <ng-container *ngIf="liveUpcomingTab; else resultTab">
        <div class="no-items no-results-placeholder-div">
          <ng-container *ngIf="groupType == groupTypes.Trivia">
            <div class="svg svg-info vs-svg ms-auto me-auto" fgbAnimateSvg [inlineSVG]="'assets/images/games/trivia.svg'"></div>
            <div class="no-results-placeholder">{{ 'fgbcl.game.no.trivia.game.available.text' | translate }}</div>
          </ng-container>
          <ng-container *ngIf="groupType == groupTypes.Predictor">
            <div
              class="svg svg-info vs-svg ms-auto me-auto"
              fgbAnimateSvg
              [inlineSVG]="'assets/images/games/Predictor.svg'"
            ></div>
            <div class="no-results-placeholder">{{ 'fgbcl.game.no.predictor.game.available.text' | translate }}</div>
          </ng-container>
        </div>
      </ng-container>
      <ng-template #resultTab>
        <div class="no-items no-results-placeholder-div">
          <div class="svg svg-info vs-svg ms-auto me-auto" fgbAnimateSvg [inlineSVG]="'assets/images/games/Results.svg'"></div>
          <div class="no-results-placeholder">{{ 'fgbcl.game.no.trivia.result.available.text' | translate }}</div>
        </div>
      </ng-template>
    </div>
  </ng-template>
</div>
